import type { FaireProductEntity } from "../../entity_types/product";

export const p_fyvc42m56b: FaireProductEntity = {
  token: "p_fyvc42m56b",
  type: "product",
  name: "Cheese Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/b53290a0d2f9bff5534eed08117dcc038983c2f710ecefa3a00439580215527c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a02cf5cfc92a6d9ef832ad7a36bf88f9dd21e9d39a6a0dddbcbf28a444c9702f.jpeg",
    "https://cdn.faire.com/fastly/ad5791f3138e08a521da98f5dc10f316b93c0e26ef5f567e7cc1bd8b086e38ae.jpeg",
    "https://cdn.faire.com/fastly/8d5c14c09fbb911a1974178f13aff7cdc0eb6523e5baf0961707fbe1408a1554.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:21.631Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
